import ReservationStepper from "../components/reservation/Steeper";

export default function ReservationDetailPage() {
    return (
        <div className={'flex flex-col w-full h-full items-center justify-center pb-2'}>
            <ReservationStepper isAdmin={false}/>
        </div>
    )
}
